<template>
    <div>
        <ul id="articleList">
            <li v-for="value in articleListData" :data-type="value.type" :data-urlid="value.urlid" :key="value">
                <div class="info">
                    <h3><a :href="value.url">{{value.title}}</a></h3>
                    <p>{{value.modifytime}} 已发布</p>
                    <p :id="value.urlid">
                        <span><span class="read-icon"></span><span class="readPv">{{value.readpv}}</span></span><i></i>&nbsp;&nbsp;<span><span class="comment-icon"></span><span class="commentPv">{{value.commentpv}}</span></span>
                    </p>
                </div>
                <div class="cover-pic">
                    <a :href="value.url">
                        <img :src="value.minisrc" alt="">
                    </a>
                </div>
            </li>
        </ul>
        <Loading v-if="loadingShow"></Loading>
        <NoMore v-if="noData"></NoMore>
    </div>
</template>

<script>
    import {getmaininfo, getPageview} from './../../axios/api.js'
    import Loading from './../loading.vue'
    import NoMore from './../loadingNoMore.vue'
    let pgno;
	export default {
	  	data() {
		    return {
                articleListData: [],
                loadingShow: false,
                noData: false,
                loadSwitch: true,
                pgno: 1,
		    }
	  	},
        activated(){
            this.pgno = 1;
        },
        mounted(){
            this.getmaininfo(1, 1);
            // 注册scroll事件并监听 
            // let that = this;
            pgno = this.pgno;
            window.addEventListener('scroll', this.scrollLoadData)
                
        },
        beforeDestroy (){
            window.removeEventListener('scroll', this.scrollLoadData);
        },
        components: {
            Loading,
            NoMore
        },
        methods: {
            scrollLoadData (){
                let releaseSelected = document.getElementsByClassName('vue-tab')[1].getAttribute('aria-selected');
                // console.log(document.documentElement.clientHeight+'-----------'+window.innerHeight); // 可视区域高度  
                // console.log(document.body.scrollTop); // 滚动高度  
                // console.log(document.documentElement.scrollTop); // 滚动高度  
                // console.log(document.body.offsetHeight); // 文档高度  
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                let innerHeight = window.innerHeight;
                let offsetHeight = document.body.offsetHeight;
                // 判断是否滚动到底部  
                if(scrollTop + innerHeight >= offsetHeight) { 
                    // 如果开关打开则加载数据  
                    if(this.loadSwitch && !this.noData && releaseSelected == 'true'){
                        pgno++;
                        this.getmaininfo(pgno,1);
                    }
                }
            },
            getmaininfo (pgno, passType){ // 获取近期发布文章数据
                this.loadSwitch = false;
                let params = {
                    pgno: pgno,
                    pgsize: 10,
                    type:passType,
                    later: 7
                }
                this.loadingShow = true;
                let that = this;
                getmaininfo(params).then( result => {
                    if(result.stat == 1){
                        if(!result.data.length){
                            that.loadingShow = false;
                            that.noData = true;
                            return false;
                        }else{
                            let maininfoData = result.data;
                            let urlidArr = [];
                            for(let i=0;i<maininfoData.length;i++){
                                urlidArr.push(maininfoData[i].urlid);
                            }
                            urlidArr=urlidArr.join(',');
                            let viewParams={
                                urlids:urlidArr
                            };
                            getPageview(viewParams).then( res => {
                                if(res.stat == 1){
                                    let pageviewData = res.data;
                                    // console.log(res)
                                    for(let i = 0; i < maininfoData.length; i++){
                                        for(let j = 0; j < pageviewData.length; j++){
                                            if(maininfoData[i].urlid == pageviewData[j].urlid){
                                                maininfoData[i].readpv = pageviewData[j].readpv;
                                                maininfoData[i].commentpv = pageviewData[j].commentpv;
                                            }
                                        }
                                        that.articleListData.push(maininfoData[i]);
                                    }
                                    if(maininfoData.length < 10){
                                        that.noData = true;
                                    }else{
                                        that.noData = false;
                                    }
                                    that.loadingShow = false;
                                    that.loadSwitch = true;
                                }
                            })
                        }
                    }
                })
            },
        }
	}
</script>
<style scoped>    
    #articleList li {
        width: 100%;
        height: 2.4rem;
        background: #fff;
        border-bottom: 1px solid #e1e1e1;
        padding: 0.3rem;
    }

    #articleList li .info {
        width: 4rem;
        float: left;
    }

    #articleList li .info h3 {
        font-size: 0.34rem;
        font-weight: normal;
        line-height: 0.44rem;
        height: 0.88rem;
        overflow: hidden;
    }

    #articleList li .info h3 a {
        display: inline-block;
        color: #333333;
        height: 100%;
        overflow: hidden;
    }

    #articleList li .info p {
        color: #999999;
        font-size: 0.24rem;
        margin: 0.1rem 0;
    }

    #articleList li .info p:last-child {
        color: #999999;
        font-size: 0.28rem;
        margin-bottom: 0;
        margin-top: 0.15rem;
    }
    #articleList li .info p:last-child > span {
        display: inline-block;
        margin-right: 0.2rem;
        overflow: hidden;
    }
    #articleList li .info p:last-child > span span{
        float: left;
        margin-right: 0.1rem;
        font-size: 0.24rem;
    }
    #articleList li .info p .read-icon{
        display: inline-block;
        width: 0.38rem;
        height: 0.38rem;
        background: url('./../../assets/img/read-icon.png') no-repeat center center;
        background-size: 0.38rem 0.38rem;
        position: relative;
        top: -0.028rem;
    }

    #articleList li .info p .comment-icon{
        display: inline-block;
        width: 0.38rem;
        height: 0.38rem;
        background: url('./../../assets/img/comment-icon.png') no-repeat center center;
        background-size: 0.38rem 0.38rem;
        position: relative;
        top: -0.02rem;
    }

    #articleList li .cover-pic {
        float: right;
        width: 2.4rem;
        height: 1.8rem;
    }

    #articleList li .cover-pic img {
        width: 100%;
    }

    #articleList li:last-child {
        margin-bottom: 0
    }
</style>




// WEBPACK FOOTER //
// src/components/homepage/recentlyRelease.vue